var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaylistsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 2.625a.869.869 0 0 0-.875.875h9.625A.875.875 0 0 0 14 2.625H6.125zM3.5 3.5c0 .05.004.097.012.144A2.619 2.619 0 0 0 1.75 6.125c0 .05.004.097.012.144A2.619 2.619 0 0 0 0 8.75v8.75a2.625 2.625 0 0 0 2.625 2.625h15.75A2.63 2.63 0 0 0 21 17.5V8.75a2.625 2.625 0 0 0-2.625-2.625c0-1.152-.74-2.124-1.762-2.48a.88.88 0 0 0 .012-.145A2.625 2.625 0 0 0 14 .875H6.125A2.619 2.619 0 0 0 3.5 3.5zm0 2.625c0-.488.387-.875.875-.875H15.75c.482 0 .875.39.875.875H3.5zM1.75 8.75c0-.488.387-.875.875-.875h15.75c.482 0 .875.39.875.875v8.75a.88.88 0 0 1-.875.875H2.625a.875.875 0 0 1-.875-.875V8.75zm8.66.308c-1.016-.74-2.535-.068-2.535 1.267v5.6c0 1.335 1.519 2.006 2.535 1.267l.002-.002 3.816-2.799h.001c.861-.63.861-1.902 0-2.532l-3.817-2.8h-.002zm2.586 4.067-3.371-2.472v4.944l3.371-2.472z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistsWhite);
export default __webpack_public_path__ + "static/media/playlists-white.3651e4ca8e187da933d82b08ea3f5952.svg";
export { ForwardRef as ReactComponent };